<template>
  <div>
    <!--    头部-->
    <div class="ele-admin-header">
      <div class="ele-admin-logo">
        <img src="@/assets/logo.svg" alt="logo" />
        <span>{{ $setting.name }}</span>
        <el-divider direction="vertical" />
        <!--        <img src="https://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/ydzhxylogo.png" alt="" @click="gotoUrl" class="ydlogohover">-->
        <!--        <span @click="gotoUrl" class="ydlogohover">智慧校园</span>-->
      </div>
      <el-menu :default-active="activeIndex" mode="horizontal">
        <el-menu-item index="1">首页</el-menu-item>
        <el-menu-item index="2">学校新闻</el-menu-item>
        <el-menu-item index="3">功能使用</el-menu-item>
        <el-menu-item index="4">联系我们</el-menu-item>
        <a class="loginButton" @click="showLogin = true">登录</a>
      </el-menu>
    </div>
    <!--    轮播图-->
    <div class="carousel">
      <el-carousel trigger="click" height="30vw">
        <el-carousel-item v-for="item in bannerImg" :key="item">
          <img :src="item" alt="" style="width: 100%; height: auto" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!--    功能简介-->
    <div class="aboutUs">
      <div style="text-align: center; margin: 30px auto">
        <img src="http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/aboutus.png" alt="" width="85%" />
      </div>
      <div class="function">
        <div class="function-item" v-for="(item, index) in functionitem" :key="index">
          <div class="function-item-content">
            <div class="functionImg">
              <img :src="item.img" alt="" height="80" />
            </div>
            <span style="margin-top: 30px">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="function" v-if="more === 1">
        <div class="function-item" v-for="(item, index) in elsefunction" :key="index">
          <div class="function-item-content">
            <div class="functionImg">
              <img :src="item.img" alt="" height="80" />
            </div>
            <span style="margin-top: 30px">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="more" @click="moreClick">{{ moreText }}</div>
    </div>
    <!--    校园新闻-->
    <div class="news">
      <div style="text-align: center">
        <img src="http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/aboutnew.png" alt="" width="85%" />
      </div>
      <div class="news-container">
        <div class="new-item" v-for="(item, index) in news" :key="index">
          <div
            style="
              width: 15%;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              line-height: 35px;
            "
          >
            <div style="font-size: 23px">
              {{ item.createTime | toDateString('MM-dd') }}
            </div>
            <div class="year">{{ item.createTime | toDateString('yyyy') }}</div>
          </div>
          <div style="width: 85%">
            <div class="newtitle">{{ item.title }}</div>
            <div class="content">{{ item.describe }}</div>
          </div>
        </div>
      </div>
      <div class="viewmore">查看更多</div>
    </div>
    <!--    联系我们-->
    <div class="contact">
      <div style="text-align: center; margin: 30px auto">
        <img src="http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/contactus.png" alt="" width="80%" />
      </div>
      <el-row class="company">
        <el-col>
          <div class="company-item" style="background-color: #409eff; color: #ffffff">
            <div class="title">石家庄</div>
            <el-row style="width: 90%; margin: 5px auto">
              <el-col :span="8">客服电话：</el-col>
              <el-col :span="16">
                <div>0311-86990802</div>
                <div>0311-86990832</div>
                <div>0311-86990528</div>
                <div>15831994140</div>
              </el-col>
            </el-row>
            <el-row style="width: 90%; margin: 5px auto">
              <el-col :span="8">客服QQ：</el-col>
              <el-col :span="16">
                <div>hebxxt@qq.com</div>
                <div>493204500</div>
                <div>1511521737</div>
              </el-col>
            </el-row>
            <el-row style="width: 90%; margin: 5px auto">
              <el-col :span="8">客服邮箱：</el-col>
              <el-col :span="16">
                <div>xxtheb@139.com</div>
                <div>hebxxt@163.com</div>
              </el-col>
            </el-row>
            <el-row style="width: 90%; margin: 5px auto">
              <el-col :span="8">新闻热线：</el-col>
              <el-col :span="16">
                <div>0311-86990852</div>
              </el-col>
            </el-row>
            <el-row style="width: 90%; margin: 0 auto">
              <el-col :span="8">新闻邮箱：</el-col>
              <el-col :span="16">
                <div>hebxxtn@qq.com</div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col>
          <div class="company-item" style="background-color: #d6dcf6; color: #2b41ae">
            <el-tabs v-model="activeName1">
              <el-tab-pane label="保定" name="baoding">
                <el-row style="width: 90%; margin: 5px auto">
                  <el-col :span="8">客服电话：</el-col>
                  <el-col :span="16">
                    <div>0312-3083892</div>
                    <div>0312-3083592</div>
                    <div>15132201695</div>
                  </el-col>
                </el-row>
                <el-row style="width: 90%; margin: 5px auto">
                  <el-col :span="8">客服QQ：</el-col>
                  <el-col :span="16">
                    <div>1098078058</div>
                  </el-col>
                </el-row>
                <el-row style="width: 90%; margin: 5px auto">
                  <el-col :span="8">客服邮箱：</el-col>
                  <el-col :span="16">
                    <div>13400223300@139.com</div>
                  </el-col>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="邢台" name="xingtai">
                <el-row style="width: 90%; margin: 5px auto">
                  <el-col :span="8">客服电话：</el-col>
                  <el-col :span="16">
                    <div>0319-3138218</div>
                    <div>18833417071</div>
                  </el-col>
                </el-row>
                <el-row style="width: 90%; margin: 5px auto">
                  <el-col :span="8">客服QQ：</el-col>
                  <el-col :span="16">
                    <div>2226406604</div>
                  </el-col>
                </el-row>
                <el-row style="width: 90%; margin: 5px auto">
                  <el-col :span="8">客服邮箱：</el-col>
                  <el-col :span="16">
                    <div>hebxxtxt@163.com</div>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
        <el-col>
          <div class="company-item" style="background-color: #409eff; color: #ffffff">
            <el-tabs v-model="activeName2">
              <el-tab-pane label="唐山" name="tangshan">
                <el-row style="width: 90%; margin: 5px auto">
                  <el-col :span="8">客服电话：</el-col>
                  <el-col :span="16">
                    <div>0315-3195692</div>
                    <div>0312-7116533</div>
                    <div>400-1145692</div>
                  </el-col>
                </el-row>
                <el-row style="width: 90%; margin: 5px auto">
                  <el-col :span="8">客服QQ：</el-col>
                  <el-col :span="16">
                    <div>1114305887</div>
                  </el-col>
                </el-row>
                <el-row style="width: 90%; margin: 5px auto">
                  <el-col :span="8">客服邮箱：</el-col>
                  <el-col :span="16">
                    <div>15081966619@139.com</div>
                  </el-col>
                </el-row>
              </el-tab-pane>
              <el-tab-pane label="廊坊" name="langfang">
                <el-row style="width: 90%; margin: 5px auto">
                  <el-col :span="8">客服电话：</el-col>
                  <el-col :span="16">
                    <div>0316-7273707</div>
                  </el-col>
                </el-row>
                <el-row style="width: 90%; margin: 5px auto">
                  <el-col :span="8">客服QQ：</el-col>
                  <el-col :span="16">
                    <div>935221931</div>
                  </el-col>
                </el-row>
                <el-row style="width: 90%; margin: 5px auto">
                  <el-col :span="8">客服邮箱：</el-col>
                  <el-col :span="16">
                    <div>15930122671@139.com</div>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--    尾部-->
    <div class="foot">
      <el-image style="width: 150px; height: 150px; margin: 20px auto" :src="qrUrl" fit="fill" />
      <div style="margin-bottom: 20px">
        <span style="color: #fff">copyright © 2021 hbztxy.com all rights reserved.</span>
        <a href="http://www.beian.miit.gov.cn/">冀ICP备06010282号-4</a>
      </div>
    </div>
    <!--登录框-->
    <el-dialog title="登录" :visible.sync="showLogin" width="360px">
      <el-form ref="loginForm" :model="form" :rules="rules" class="login-form ele-bg-white" size="large" @keyup.enter.native="doSubmit">
        <h4>智校园管理系统</h4>
        <el-form-item prop="phone">
          <el-input placeholder="请输入手机号码" v-model="form.phone" maxlength="11" prefix-icon="el-icon-user" clearable />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            placeholder="请输入密码"
            v-model="form.password"
            maxlength="8"
            prefix-icon="el-icon-lock"
            show-password
            @input="getTeachSchool()"
          />
        </el-form-item>
        <el-form-item>
          <el-select style="width: 100%" v-model="form.schoolAccount" placeholder="请选择学校" prefix-icon="el-icon-school">
            <el-option v-for="item in schoolList" :key="item.id" :label="item.schoolName" :value="item.schoolAccount" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showLogin = false">取 消</el-button>
        <el-button @click="doSubmit" :loading="loading" type="primary" size="large">
          {{ loading ? '登录中' : '登 录' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { login, getTeacherSchools, hdAccess } from '../../config/api.js';
  import validate from '@/utils/validate';
  export default {
    name: 'HdLogin',
    data() {
      return {
        activeIndex: '1',
        qrUrl: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/qrcode.jpg',
        bannerImg: ['http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/banner5.png'],
        activeName1: 'baoding',
        activeName2: 'tangshan',
        news: [
          {
            title: '深改委重磅会议 习近平为这些事指明方向',
            describe:
              '7月9日，中共中央总书记、国家主席、中央军委主席、中央全面深化改革委员会主任习近平主持召开中央全面深化改革委员会第二十次会议，\n' +
              '审议通过了《关于加快构建新发展格局的指导意见》、《种业振兴行动方案》、《青藏高原生态环境保护和可持续发展方案》、《关于推进\n' +
              '自由贸易试验区贸易投资便利化改革创新的若干措施》。',
            createTime: '2021-07-14',
          },
          {
            title: '深改委重磅会议 习近平为这些事指明方向',
            describe:
              '7月9日，中共中央总书记、国家主席、中央军委主席、中央全面深化改革委员会主任习近平主持召开中央全面深化改革委员会第二十次会议，\n' +
              '审议通过了《关于加快构建新发展格局的指导意见》、《种业振兴行动方案》、《青藏高原生态环境保护和可持续发展方案》、《关于推进\n' +
              '自由贸易试验区贸易投资便利化改革创新的若干措施》。',
            createTime: '2021-07-14',
          },
        ],
        functionitem: [
          {
            name: '办公短信',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function3.png',
          },
          {
            name: '学生请假',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function1.png',
          },
          {
            name: '学生考勤',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function2.png',
          },
          {
            name: '家校通知',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function4.png',
          },
        ],
        elsefunction: [
          {
            name: '邮件',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function5.png',
          },
          {
            name: '学生点名',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function6.png',
          },
          {
            name: '巡查管理',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function7.png',
          },
          {
            name: '成绩管理',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function8.png',
          },
          {
            name: '学生行为评价',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function9.png',
          },
          {
            name: '教师考勤',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function10.png',
          },
          {
            name: '体温统计',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function11.png',
          },
          {
            name: '访客管理',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function12.png',
          },
          {
            name: '失物招领',
            img: 'http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/function13.png',
          },
        ],
        more: 0,
        moreText: '查看更多',
        showLogin: false,
        form: { phone: '', password: '', schoolAccount: '' }, // 表单数据
        rules: {
          // 表单验证规则
          phone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
          password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        },
        loading: false, // 加载状态
        schoolList: [],
      };
    },
    created() {
      if (this.$route.query) {
        console.log(this.$route.query);
        let formData = new FormData();
        formData.append('token', this.$route.query.access_token.replace(/ /g, '+'));
        formData.append('idn', this.$route.query.idn.replace(/ /g, '+'));
        hdAccess(formData).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: '登录成功' });
            this.$store.dispatch('user/setToken', res.data.data.token).then(() => {
              this.$router.push('/').catch(() => {});
            });
            this.$store.dispatch('user/setUser', res.data.data.teacherName);
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      }
    },
    mounted() {
      if (this.$store.state.user.token) this.$router.push(this.$route.query.from || '/');
    },
    methods: {
      // 查看更多
      moreClick() {
        if (this.more === 0) {
          this.moreText = '收起';
          this.more = 1;
        } else {
          this.moreText = '查看更多';
          this.more = 0;
        }
      },
      /* 提交 */
      doSubmit() {
        this.$refs['loginForm'].validate((valid) => {
          if (!valid) return false;
          this.loading = true;
          let formData = new FormData();
          for (let key in this.form) formData.append(key, this.form[key]);
          login(formData).then((res) => {
            this.loading = false;
            if (res.data.resCode == 200) {
              this.$message({ type: 'success', message: '登录成功' });
              this.$store.dispatch('user/setToken', res.data.data.token).then(() => {
                this.$router.push(this.$route.query.from || '/').catch(() => {});
                // this.$router.push('/school/teacher')
              });
              this.$store.dispatch('user/setUser', res.data.data.teacherName);
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
      //根据手机号 获取学校信息
      getTeachSchool() {
        if (validate.isPhone(this.form.phone)) {
          if (this.form.password != '') {
            let data = {
              phone: this.form.phone,
              password: this.form.password,
            };
            getTeacherSchools(data).then((res) => {
              if (res.data.resCode == 200) {
                this.schoolList = res.data.data;
                this.form.schoolAccount = res.data.data[0].schoolAccount;
              }
            });
          }
        }
      },
      gotoUrl() {
        // window.open('http://he.andedu.com.cn')
      },
    },
  };
</script>

<style scoped>
  a {
    font-size: 16px;
    color: #ffffff !important;
    font-weight: bolder;
    text-decoration: none;
  }
  .ydlogohover:hover {
    cursor: pointer;
  }
  .ele-admin-header {
    justify-content: space-between;
    padding-left: 150px;
    padding-right: 150px;
  }
  .ele-admin-header .ele-admin-logo {
    width: 380.5px;
    box-shadow: none;
  }
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus {
    color: #409eff;
  }
  /deep/ .ele-admin-header .el-menu.el-menu--horizontal > .el-menu-item {
    padding: 0 50px;
  }
  /deep/ .el-carousel__button {
    width: 13px;
    height: 13px;
    border-radius: 13px;
    background-color: #ffffff;
  }
  /deep/ .el-carousel__indicator.is-active button {
    opacity: 1;
    background-color: #409eff;
  }
  .contact {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
    padding: 30px 0 30px 0;
  }
  .company {
    width: 60%;
    margin: 0 auto;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
  .company-item {
    height: 375px;
    background: #f5f5f5;
    margin-top: 20px;
  }
  .foot {
    width: 100%;
    background-color: #626061;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .foot a {
    color: #ffffff !important;
    font-size: 14px;
    font-weight: normal;
  }
  .company-item {
    font-size: 15px;
    line-height: 25px;
  }
  .title {
    font-size: 15px;
    /*background-color: #409EFF;*/
    text-align: center;
    line-height: 50px;
    color: #ffffff;
  }
  /deep/ .el-tabs__nav-scroll {
    padding-left: 15px;
    height: 50px;
    line-height: 50px;
    /*background-color: #409EFF;*/
    /*color: #FFFFFF;*/
  }
  /deep/ .el-tabs__active-bar {
    background-color: #ffffff;
  }
  /deep/ .el-tabs__item:hover {
    color: #ffffff;
  }
  /deep/ .el-tabs__item.is-active {
    color: #2b41ae;
  }
  .aboutUs {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /*margin: 50px auto;*/
    /*background-color: #FFFFFF;*/
    padding: 30px 0 30px 0;
  }
  .news {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    padding: 30px 0 30px 0;
    background: url('http://hexiaoyuan.oss-cn-beijing.aliyuncs.com/indexIcon/newBg.png') no-repeat;
  }
  .news-container {
    width: 50%;
    margin: 0 auto;
  }
  .new-item {
    display: flex;
    margin-top: 50px;
  }
  .newtitle {
    font-size: 20px;
    line-height: 35px;
  }
  .content {
    line-height: 25px;
  }
  .viewmore {
    width: 130px;
    height: 40px;
    margin: 0 auto;
    margin-top: 30px;
    background-color: #409eff;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    transition: all 0.3s ease;
    border-radius: 6px;
  }
  .viewmore:hover {
    background-color: #ffffff;
    color: #409eff;
    font-weight: 700;
    font-size: 16px;
  }
  .more {
    width: 130px;
    height: 40px;
    margin: 0 auto;
    margin-top: 30px;
    border: 1px solid #409eff;
    color: #409eff;
    text-align: center;
    line-height: 40px;
    transition: all 0.3s ease;
  }
  .more:hover {
    background-color: #409eff;
    color: #ffffff;
    font-weight: 700;
    font-size: 16px;
  }
  .function {
    width: 50%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    padding-left: 20px;
    transition: all 0.3s ease;
  }
  .function-item {
    flex-basis: 25%;
    margin-top: 40px;
    padding-right: 20px;
    font-size: 17px;
    color: #2b41ae;
    position: relative;
    box-sizing: border-box;
  }
  .function-item-content {
    padding: 30px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    box-sizing: border-box;
    height: 100%;
    background-color: #ffffff;
  }
  .functionImg {
    position: relative;
    display: inline-block;
  }
  @media screen and (max-width: 1366px) {
    .company {
      width: 75%;
      margin: 0 auto;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
  }
  @media screen and (max-width: 768px) {
    .company {
      width: 90%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .company-item {
      margin: 5px auto;
    }
    .company-item {
      height: auto;
    }
  }
  .loginButton {
    padding: 10px 15px;
    background: #409eff;
    border-radius: 6px;
    cursor: pointer;
  }
  .login-form h4 {
    font-weight: bold;
    text-align: center;
    margin: 0 0 25px 0;
  }

  .login-form > .el-form-item {
    margin-bottom: 25px;
  }
  .login-btn {
    display: block;
    width: 100%;
  }
</style>
